import { OLAF, OZ, BATTLESHIP, CANDY_APPLE, KOALA, HEFFALUMP, GYPSUM, CHART_GREEN, CHART_ORANGE, CHART_RED, TRELLIS_HAPPY, TRELLIS_NEUTRAL, TRELLIS_SAD, BUTTON_DISABLED_TEXT, SLINKY, NEUTRAL_1600, NEUTRAL_1000, NEUTRAL_800, NEUTRAL_700, NEUTRAL_600 } from '../constants/WidgetColors';
export const WHITE = OLAF;
export const GREEN = OZ;
export const GREY = BATTLESHIP;
export const DEFAULT_PRIMARY_COLOR = NEUTRAL_1600;
export const DEFAULT_TEXT_COLOR = NEUTRAL_1600;
export const DEFAULT_ERROR_TEXT_COLOR = CANDY_APPLE;
export const DISABLED_BACKGROUND_COLOR = KOALA;
export const DISABLED_TEXT_COLOR = BUTTON_DISABLED_TEXT;
export const DEFAULT_HELP_TEXT_COLOR = HEFFALUMP;

/* Input Colors */
export const DEFAULT_INPUT_BORDER_COLOR = NEUTRAL_800;
export const DEFAULT_INPUT_BORDER_COLOR_DISABLED = NEUTRAL_600;
export const DEFAULT_INPUT_BACKGROUND_COLOR = GYPSUM;
export const DEFAULT_PLACEHOLDER_TEXT_COLOR = NEUTRAL_1000;
export const UPDATED_INPUT_BORDER_COLOR = NEUTRAL_800;
export const DEFAULT_HAPPY_COLOR = CHART_GREEN;
export const DEFAULT_NEUTRAL_COLOR = CHART_ORANGE;
export const DEFAULT_SAD_COLOR = CHART_RED;
export const DEFAULT_TRELLIS_HAPPY_COLOR = TRELLIS_HAPPY;
export const DEFAULT_TRELLIS_NEUTRAL_COLOR = TRELLIS_NEUTRAL;
export const DEFAULT_TRELLIS_SAD_COLOR = TRELLIS_SAD;

/* Button Colors */
export const DEFAULT_DISABLED_BUTTON_BACKGROUND_COLOR = OLAF;
export const DEFAULT_DISABLED_BUTTON_BORDER_COLOR = BATTLESHIP;
export const DEFAULT_DISABLED_BUTTON_TEXT_COLOR = SLINKY;

/* Icon Button Colors */
export const DEFAULT_ICON_BUTTON = NEUTRAL_1600;
export const DEFAULT_ICON_BUTTON_DISABLED = NEUTRAL_700;
export const DEFAULT_ICON_BUTTON_HOVER = NEUTRAL_700;